module.exports = __webpack_public_path__ + "img/clock.49ada973.svg";